/**
@summary define constants used throughout the app

This module defines various constants for reference throughout the codebase.

@module utils.const
@author Bryant Finney <bryant@outdoorlinkinc.com>

**/

// enumerate status types from the backend
export const STATUS_TYPE = {
  SHORT: 1,
  LONG: 2,
  CRC: 3,
  COMMERCIAL: 9,
  TWO_PORT_DC: 13,
};

export const SMARTLINK_MODEL = {
  SL_302: 1,
  SL_302M: 2,
  SL_SOLAR: 3,
  SL_WALLSCAPE: 4,
  SL_TRIFACE: 5,
  SL_303: 6,
  SL_302M_WITH_DOW: 7,
  SL_302I: 8,
  SL_702I: 9,
  SL_ONE: 10,
  SL_SOLAR_ANSI: 11,
  SL_DC_WITHOUT_DOW: 12,
  SL_DC_WITH_DOW: 13,
  SL_ONE_WITH_DOW: 14,
  SL_TWO_PORT_DC: 15,
  VANTAGE: 16,
  ODL_1_SERIES_AC: 17,
  ODL_2_SERIES_AC: 18,
  ODL_4_SERIES_AC_AC: 19,
};
